var _symbol, _symbol2, _symbol3, _symbol4, _symbol5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-Back-Arrow",
    viewBox: "0 0 15 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.58 30.72c0.582-0.498 0.641-1.363 0.132-1.932l-11.45-12.788 11.45-12.788c0.509-0.569 0.45-1.434-0.132-1.932s-1.467-0.44-1.977 0.129l-12.257 13.69c-0.462 0.516-0.462 1.287 0 1.803l12.257 13.69c0.509 0.569 1.394 0.627 1.977 0.129z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-Logo",
    viewBox: "0 0 235 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    style: {
      fill: "var(--color1, #262626)"
    },
    d: "M11.959 1.166c1.55 0 2.982 0.374 4.297 1.12s2.347 1.757 3.095 3.033c0.748 1.276 1.122 2.672 1.122 4.191 0 2.306-0.831 4.274-2.491 5.902s-3.669 2.442-6.022 2.442h-6.935v11.802h-5.024v-28.49h11.959zM11.959 12.928c0.97 0 1.792-0.331 2.471-0.996s1.016-1.471 1.016-2.422c0-0.95-0.34-1.757-1.016-2.422-0.678-0.665-1.501-0.996-2.471-0.996h-6.935v6.838l6.935-0.002z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    style: {
      fill: "var(--color1, #262626)"
    },
    d: "M40.777 1.166h5.024v28.49h-5.024v-11.762h-12.167v11.762h-5.024v-28.49h5.024v11.762h12.167v-11.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    style: {
      fill: "var(--color1, #262626)"
    },
    d: "M56.163 3.079c2.228-1.274 4.658-1.913 7.288-1.913s5.060 0.637 7.288 1.913 3.993 3.005 5.295 5.189c1.3 2.184 1.952 4.565 1.952 7.143s-0.65 4.959-1.952 7.143c-1.302 2.184-3.066 3.915-5.295 5.189-2.228 1.276-4.657 1.913-7.288 1.913s-5.060-0.637-7.288-1.913c-2.228-1.274-3.995-3.005-5.295-5.189-1.302-2.184-1.952-4.565-1.952-7.143s0.65-4.959 1.952-7.143c1.3-2.184 3.066-3.913 5.295-5.189zM56.723 22.004c1.855 1.818 4.096 2.728 6.726 2.728s4.872-0.908 6.726-2.728c1.855-1.818 2.783-4.014 2.783-6.593s-0.928-4.775-2.783-6.593c-1.854-1.818-4.097-2.727-6.726-2.727s-4.872 0.91-6.726 2.727c-1.854 1.818-2.782 4.016-2.782 6.593s0.926 4.775 2.782 6.593z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    style: {
      fill: "var(--color1, #262626)"
    },
    d: "M79.024 1.166h20.472v4.924h-7.724v23.566h-5.024v-23.566h-7.724v-4.924z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    style: {
      fill: "var(--color1, #262626)"
    },
    d: "M107.78 3.079c2.228-1.274 4.657-1.913 7.288-1.913s5.060 0.637 7.288 1.913 3.993 3.005 5.295 5.189c1.3 2.184 1.952 4.565 1.952 7.143s-0.65 4.959-1.952 7.143c-1.302 2.184-3.067 3.915-5.295 5.189-2.228 1.276-4.658 1.913-7.288 1.913s-5.060-0.637-7.288-1.913c-2.229-1.274-3.995-3.005-5.295-5.189-1.302-2.184-1.952-4.565-1.952-7.143s0.65-4.959 1.952-7.143c1.3-2.184 3.066-3.913 5.295-5.189zM108.34 22.004c1.855 1.818 4.096 2.728 6.727 2.728s4.872-0.908 6.726-2.728c1.854-1.818 2.782-4.014 2.782-6.593s-0.928-4.775-2.782-6.593c-1.855-1.818-4.098-2.727-6.726-2.727s-4.872 0.91-6.727 2.727c-1.854 1.818-2.782 4.016-2.782 6.593s0.926 4.775 2.782 6.593z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30c",
    style: {
      fill: "var(--color2, #30c)"
    },
    d: "M140.482 0.532c2.619-0.225 5.097 0.203 7.431 1.284s4.245 2.654 5.736 4.718c1.49 2.064 2.351 4.381 2.58 6.948 0.229 2.569-0.207 4.996-1.31 7.281-1.103 2.287-2.708 4.162-4.814 5.622-2.106 1.462-4.47 2.304-7.089 2.528l-8.647 0.742-2.533-28.382 8.645-0.742zM142.577 24.008c2.619-0.225 4.765-1.32 6.439-3.289 1.672-1.969 2.401-4.237 2.185-6.806s-1.328-4.679-3.337-6.333c-2.011-1.652-4.325-2.366-6.945-2.142l-3.639 0.313 1.657 18.57 3.639-0.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30c",
    style: {
      fill: "var(--color2, #30c)"
    },
    d: "M180.549 10.060c-0.143 1.595-0.701 3.018-1.672 4.269-0.973 1.252-2.194 2.167-3.664 2.749l3.545 13.051-5.336-0.457-3.297-12.090-5.708-0.49-1.046 11.718-5.005-0.429 2.531-28.382 11.914 1.022c2.343 0.201 4.271 1.184 5.781 2.946 1.511 1.764 2.162 3.795 1.958 6.092zM171.765 12.74c0.966 0.083 1.815-0.177 2.55-0.783 0.735-0.604 1.144-1.372 1.227-2.306 0.082-0.932-0.182-1.766-0.799-2.499s-1.405-1.142-2.371-1.225l-6.909-0.593-0.609 6.812 6.911 0.593z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30c",
    style: {
      fill: "var(--color2, #30c)"
    },
    d: "M189.598 23.323l-4.914 4.302 23.431 1.32-4.397-4.827-14.12-0.796z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30c",
    style: {
      fill: "var(--color2, #30c)"
    },
    d: "M188.738 7.683l-4.386-4.814-1.347 22.966 4.923-4.309 0.811-13.843z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30c",
    style: {
      fill: "var(--color2, #30c)"
    },
    d: "M204.691 6.851l4.911-4.3-23.417-1.32 4.397 4.825 14.108 0.796z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30c",
    style: {
      fill: "var(--color2, #30c)"
    },
    d: "M206.359 8.65l-0.811 13.826 4.388 4.816 1.346-22.953-4.922 4.311z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30c",
    style: {
      fill: "var(--color2, #30c)"
    },
    d: "M225.662 0.339c1.538-0.199 3.006-0.011 4.41 0.56 1.402 0.573 2.56 1.442 3.469 2.611 0.911 1.169 1.468 2.506 1.672 4.013 0.307 2.287-0.254 4.342-1.685 6.169-1.429 1.827-3.311 2.891-5.643 3.191l-6.874 0.888 1.572 11.703-4.981 0.643-3.793-28.245 11.853-1.532zM227.23 12.001c0.96-0.123 1.732-0.558 2.315-1.304 0.585-0.746 0.813-1.589 0.687-2.53s-0.572-1.698-1.333-2.271c-0.76-0.573-1.623-0.796-2.583-0.672l-6.874 0.888 0.911 6.779 6.876-0.889z"
  })), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 12h-11v-11c0-0.552-0.448-1-1-1h-6c-0.552 0-1 0.448-1 1v11h-11c-0.552 0-1 0.448-1 1v6c0 0.552 0.448 1 1 1h11v11c0 0.552 0.448 1 1 1h6c0.552 0 1-0.448 1-1v-11h11c0.552 0 1-0.448 1-1v-6c0-0.552-0.448-1-1-1z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-editor",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#30c",
    style: {
      fill: "var(--color1, #30c)"
    },
    d: "M31.135 15.784c0 8.359-6.776 15.135-15.135 15.135s-15.135-6.776-15.135-15.135c0-8.359 6.776-15.135 15.135-15.135s15.135 6.776 15.135 15.135z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M16 1.297c-8.001 0-14.486 6.486-14.486 14.486s6.486 14.486 14.486 14.486c8.001 0 14.486-6.486 14.486-14.486s-6.486-14.486-14.486-14.486zM0.216 15.784c0-8.717 7.067-15.784 15.784-15.784s15.784 7.067 15.784 15.784c0 8.717-7.067 15.784-15.784 15.784s-15.784-7.067-15.784-15.784z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M9.635 20.291l0.77 4.72 4.473-1.693 8.095-14.021-5.243-3.027-8.095 14.021zM18.187 7.902l3.148 1.818-1.777 3.077-3.148-1.818 1.777-3.077zM15.818 12.005l3.148 1.818-4.927 8.535-2.682 1.015-0.462-2.83 4.93-8.539-0.007 0.002z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-notify",
    viewBox: "0 0 35 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#30c",
    style: {
      fill: "var(--color1, #30c)"
    },
    d: "M27.595 4.138l-25.285 0.134c-0.305 0-0.606 0.065-0.888 0.185s-0.537 0.294-0.751 0.511c-0.214 0.218-0.384 0.475-0.5 0.758s-0.174 0.587-0.17 0.892l0.094 18.379c0 0.305 0.065 0.606 0.181 0.888 0.12 0.283 0.29 0.537 0.508 0.751s0.475 0.384 0.758 0.5c0.283 0.116 0.584 0.174 0.892 0.17l9.207-0.047c0.936 1.291 2.44 3.329 3.271 4.475 0.062 0.087 0.145 0.156 0.243 0.203s0.203 0.065 0.308 0.062c0.105-0.007 0.21-0.040 0.301-0.094s0.167-0.134 0.221-0.225l2.553-4.457 9.185-0.051c0.305 0 0.609-0.062 0.888-0.181 0.283-0.12 0.537-0.29 0.751-0.508s0.384-0.475 0.5-0.758c0.116-0.283 0.174-0.588 0.17-0.892l-0.083-18.386c0-0.308-0.062-0.613-0.181-0.896s-0.294-0.54-0.515-0.754c-0.218-0.214-0.479-0.384-0.765-0.497s-0.591-0.17-0.899-0.167l0.007 0.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M12.761 19.735c0.054 0.468 0.007 0.943-0.131 1.393s-0.37 0.867-0.678 1.226c0.66-0.062 1.284-0.334 1.78-0.772s0.841-1.026 0.979-1.675c0 0 5.983 0.714 6.694-3.329 0.758-4.261-3.619-5.487-5.483-5.483-3.26 0-5.94 1.777-6.085 4.834s2.919 3.811 2.919 3.811l0.004-0.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe5f55",
    style: {
      fill: "var(--color3, #fe5f55)"
    },
    d: "M34.902 5.403c0.007 1.077-0.305 2.132-0.899 3.028-0.591 0.899-1.436 1.603-2.43 2.020-0.99 0.417-2.085 0.533-3.14 0.326-1.055-0.203-2.031-0.718-2.796-1.476s-1.287-1.726-1.505-2.778c-0.214-1.055-0.112-2.151 0.294-3.144 0.406-0.997 1.102-1.849 1.994-2.451s1.944-0.925 3.021-0.928c1.44-0.007 2.825 0.558 3.847 1.574 1.023 1.012 1.603 2.39 1.614 3.83z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-bottom",
    viewBox: "0 0 64 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6d6d6d",
    style: {
      fill: "var(--color1, #6d6d6d)"
    },
    d: "M0.795 1.234c1.212-1.455 3.374-1.651 4.829-0.439l25.234 21.028 25.234-21.028c1.455-1.212 3.616-1.016 4.829 0.439s1.016 3.617-0.439 4.829l-27.429 22.857c-1.271 1.060-3.118 1.060-4.39 0l-27.429-22.857c-1.455-1.212-1.651-3.374-0.439-4.829z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 31 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.5484,
    d: "M23.948 7.962l-15.567 15.567M24.045 23.529l-15.567-15.567"
  })), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-Email",
    viewBox: "0 0 38 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.286 0.762h-30.476c-2.095 0-3.81 1.714-3.81 3.81v22.857c0 2.095 1.714 3.81 3.81 3.81h30.476c2.095 0 3.81-1.714 3.81-3.81v-22.857c0-2.095-1.714-3.81-3.81-3.81zM3.81 2.667h30.476c0.668 0 1.254 0.347 1.594 0.869l-16.832 16.832-16.832-16.832c0.34-0.522 0.927-0.869 1.594-0.869zM34.286 29.333h-30.476c-1.050 0-1.905-0.854-1.905-1.905v-21.51l17.143 17.143 17.143-17.143v21.51c0 1.050-0.854 1.905-1.905 1.905z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-Phone",
    viewBox: "0 0 27 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.122 24.655l-3.063-4.275c-1.421-1.984-3.116-0.801-4.238-0.017-1.555 1.087-2.358 1.532-3.604-0.207l-5.099-7.117c-1.246-1.739-0.578-2.372 0.927-3.528 1.085-0.834 2.725-2.094 1.303-4.079l-3.062-4.275c-0.823-1.148-2.283-1.502-3.256-0.789l-4.514 3.309c-1.186 0.869-1.68 2.356-1.468 4.418 0.729 7.098 10.238 20.371 16.68 23.281 0.923 0.417 1.767 0.625 2.528 0.625 0.783 0 1.478-0.22 2.079-0.661l4.514-3.309c0.972-0.713 1.095-2.227 0.272-3.375v0zM24.93 26.748l-4.514 3.309c-0.7 0.513-1.726 0.471-3.050-0.128-5.955-2.69-15.087-15.437-15.761-21.997-0.15-1.458 0.129-2.458 0.83-2.971l4.514-3.309c0.234-0.172 0.741-0.022 1.069 0.436l3.062 4.275c0.438 0.611 0.403 0.823-0.983 1.888-1.29 0.991-3.448 2.649-1.248 5.719l5.099 7.117c2.2 3.070 4.43 1.511 5.762 0.581 1.431-1.001 1.642-0.967 2.079-0.356l3.063 4.275c0.328 0.458 0.311 0.991 0.077 1.163l0-0z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-checkbox",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.6,
    d: "M8 0.8h16c3.976 0 7.2 3.224 7.2 7.2v16c0 3.976-3.224 7.2-7.2 7.2h-16c-3.976 0-7.2-3.224-7.2-7.2v-16c0-3.976 3.224-7.2 7.2-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.867 23.364l-8.267-8.598 1.73-1.663 6.502 6.762 10.951-11.864 1.764 1.628-12.679 13.736z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-addAvatar",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#30c",
    style: {
      fill: "var(--color1, #30c)",
      stroke: "var(--color1, #30c)"
    },
    stroke: "#30c",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 0.7619,
    d: "M31.619 16c0 8.626-6.993 15.619-15.619 15.619s-15.619-6.993-15.619-15.619c0-8.626 6.993-15.619 15.619-15.619s15.619 6.993 15.619 15.619z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color2, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.5238,
    d: "M16 9.143v13.714"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color2, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.5238,
    d: "M9.143 16h13.714"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-frameology",
    viewBox: "0 0 192 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M108.549 18.070c-3.964 0-6.684-3.040-6.684-7.194 0-4.188 2.785-7.329 6.684-7.329s6.684 3.107 6.684 7.329c0 4.154-2.785 7.194-6.684 7.194zM108.549 0c-6.127 0-10.321 4.796-10.321 10.876 0 6.046 4.194 10.741 10.321 10.741 6.061 0 10.255-4.695 10.255-10.741 0-6.080-4.194-10.876-10.255-10.876zM124.898 0.439h-3.604v20.738h14.122v-3.547h-10.551v-17.192h0.033zM82.304 21.177h14.22v-3.546h-10.616v-5.269h9.436v-3.58h-9.436v-4.796h10.616v-3.546h-14.22v20.738zM187.904 0.473v8.039c0 2.635-1.343 4.222-3.342 4.222-1.9 0-2.851-1.182-2.851-3.445v-8.816h-4.063l0.067 9.592c0 3.918 2.031 6.384 5.537 6.384 2.031 0 3.603-0.811 4.685-2.094v3.107c0 2.803-1.605 4.56-3.964 4.56-1.802 0-3.146-1.013-3.375-2.939l-3.866 0.54c0.196 3.749 3.21 6.080 7.241 6.080 4.815 0 8.027-3.547 8.027-8.41v-16.82h-4.096zM169.13 24.96c0 1.419-1.114 2.533-2.458 2.533-1.966 0-2.851-1.419-2.851-2.803 0-1.182 0.623-2.331 1.737-3.209 0.721-0.574 1.834-1.182 3.604-1.554v5.033h-0.033zM167.853 10.91c-0.754 0.777-1.704 1.148-2.851 1.148s-2.097-0.372-2.851-1.148c-0.754-0.811-1.114-1.79-1.114-3.006s0.36-2.229 1.114-3.006c0.754-0.811 1.704-1.182 2.851-1.182s2.097 0.372 2.851 1.182c0.786 0.777 1.147 1.79 1.147 3.006 0 1.182-0.361 2.195-1.147 3.006zM172.701 11.855v-11.382h-3.702v1.756c-1.115-1.452-2.687-2.162-4.686-2.162-1.933 0-3.571 0.777-4.947 2.297-1.343 1.52-2.031 3.344-2.031 5.539s0.689 4.053 2.031 5.573c1.376 1.52 3.014 2.263 4.947 2.263 1.999 0 3.539-0.675 4.817-2.297v2.77c-2.326 0.371-4.292 1.182-5.8 2.398-1.965 1.587-3.112 3.817-3.112 6.147 0 3.715 2.752 6.485 6.422 6.485 3.342 0 6.061-2.803 6.061-6.248v-5.37h1.966v-3.715h-1.966v-4.053zM145.67 18.070c-3.964 0-6.683-3.040-6.683-7.194 0-4.188 2.784-7.329 6.683-7.329 3.9 0 6.684 3.107 6.684 7.329 0 4.154-2.784 7.194-6.684 7.194zM145.704 0c-6.127 0-10.321 4.796-10.321 10.876 0 6.046 4.193 10.741 10.321 10.741 6.062 0 10.255-4.695 10.255-10.741 0-6.080-4.193-10.876-10.255-10.876zM0 21.177h3.604v-8.207h9.371v-3.546h-9.371v-5.404h10.55v-3.58h-14.154v20.738zM68.216 13.781c-0.262 0.371-0.59 0.54-1.081 0.54s-0.819-0.169-1.081-0.54c-0.328-0.507-0.524-1.284-0.524-2.195 0-2.128 0.655-3.817 1.573-5.1 0.95 1.283 1.573 2.972 1.573 5.1 0.033 0.912-0.131 1.723-0.459 2.195zM72.016 0.034c-1.9 0-3.506 0.54-4.882 1.452-1.376-0.912-3.014-1.452-4.882-1.452-4.030 0-7.274 3.378-7.274 7.498v13.645h3.604v-13.645c0-2.094 1.671-3.817 3.702-3.817 0.655 0 1.409 0.169 2.13 0.507-1.573 2.263-2.392 5.033-2.392 7.363 0 1.689 0.393 3.175 1.147 4.323 0.918 1.385 2.359 2.128 4.030 2.128s3.080-0.777 4.030-2.128c0.754-1.115 1.147-2.601 1.147-4.323 0-2.331-0.819-5.134-2.392-7.363 0.721-0.338 1.442-0.507 2.13-0.507 2.031 0 3.702 1.723 3.702 3.817v13.645h3.604v-13.645c-0.131-4.154-3.407-7.498-7.405-7.498zM40.628 12.396l2.949-7.566 2.949 7.566h-5.898zM41.447 0.439l-8.158 20.738h3.899l2.031-5.202h8.683l2.031 5.202h3.932l-8.191-20.738h-4.227zM25.491 9.66h-5.21v-5.674h5.21c1.9 0 3.047 1.081 3.047 2.803 0 1.824-1.18 2.871-3.047 2.871zM32.109 6.823c0-3.715-2.49-6.35-6.422-6.35h-9.010v20.738h3.604v-8.005h4.489l3.604 8.005h3.899l-3.932-8.478c2.359-0.912 3.768-3.107 3.768-5.911z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-climate-neutral",
    viewBox: "0 0 80 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M24.128 13.734l0.038 0.113 4.953-2.026c1.126-0.45 1.651-1.764 1.201-2.889l-0.075-0.113-4.953 2.026c-1.088 0.45-1.651 1.764-1.163 2.889z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M22.627 10.769l0.113 0.113 3.79-3.79c0.863-0.863 0.863-2.251 0-3.114l-0.113-0.113-3.79 3.752c-0.863 0.863-0.863 2.289 0 3.152z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M48.368 18.574h-3.077v-1.463h3.002v-1.276h-3.002v-1.351h3.077v-1.276h-4.465v6.642h4.465v-1.276z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M48.255 9.681h-2.814v-5.366h-1.501v6.679h4.315v-1.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M20.15 8.63l0.113 0.038 2.064-4.953c0.45-1.126-0.075-2.401-1.201-2.889l-0.113-0.038-2.064 4.953c-0.45 1.126 0.075 2.402 1.201 2.889z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M7.843 18.199l-0.038-0.15-4.953 2.026c-1.126 0.45-1.651 1.764-1.201 2.889l0.038 0.075 4.953-1.989c1.126-0.413 1.651-1.726 1.201-2.852z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M9.306 21.126l-0.113-0.113-3.79 3.827c-0.863 0.863-0.863 2.251 0 3.114l0.113 0.113 3.79-3.79c0.863-0.863 0.863-2.289 0-3.152z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M50.657 4.315h-1.501v6.679h1.501v-6.679z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M7.655 9.306c0.863 0.863 2.251 0.863 3.114 0l0.113-0.113-3.79-3.79c-0.863-0.863-2.251-0.863-3.114 0l-0.113 0.113 3.79 3.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M7.58 14.935v-0.15h-5.366c-1.201 0-2.214 0.976-2.214 2.214v0.15h5.366c1.238 0 2.214-1.013 2.214-2.214z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M6.604 13.134c0.3 0 0.563-0.075 0.825-0.15 0.525-0.225 0.976-0.638 1.201-1.201l0.038-0.113-4.953-2.064c-1.126-0.45-2.401 0.075-2.889 1.201v0.075l4.953 2.064c0.263 0.113 0.563 0.188 0.826 0.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M62.514 9.869h2.927l0.413 1.126h1.614l-2.589-6.642v-0.038h-1.839l-2.589 6.679h1.651l0.413-1.126zM63.978 5.704l1.051 2.889h-2.101l1.051-2.889z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M78.086 9.719h-3.265v-1.463h3.19v-1.276h-3.19v-1.351h3.265v-1.313h-4.766v6.679h4.766v-1.276z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M68.856 10.995h1.501v-5.366h1.951v-1.313h-5.366v1.313h1.914v5.366z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M70.844 13.208l-2.402 6.642h1.501l0.375-1.126h2.702l0.375 1.126h1.501l-2.401-6.604v-0.038h-1.651zM72.608 17.449h-1.951l0.976-2.889 0.976 2.889z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M49.681 13.208v3.978c0 1.764 1.013 2.777 2.814 2.777 1.764 0 2.777-1.013 2.777-2.777v-3.978h-1.388v3.94c0 0.938-0.488 1.501-1.388 1.501s-1.388-0.525-1.388-1.501v-3.94h-1.426z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M75.948 13.208v6.642h3.977v-1.313h-2.627v-5.328h-1.351z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M59.587 19.85v-5.328h1.801v-1.313h-4.991v1.313h1.801v5.328h1.388z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M67.58 15.348c0-0.075 0-0.15 0-0.225-0.038-1.126-0.976-1.989-2.101-1.914h-2.927v6.642h1.388v-2.364h0.901l1.201 2.364h1.576l-1.388-2.514c0.675-0.188 1.351-0.788 1.351-1.989zM65.253 16.211h-1.351v-1.726h1.351c0.488 0 0.863 0.375 0.863 0.863s-0.375 0.863-0.863 0.863z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M53.771 6.417l1.801 4.54v0.038h0.675l1.801-4.578v4.578h1.501v-6.679h-2.064l-1.576 4.090-1.576-4.053h-2.064v6.642h1.501v-4.578z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M11.783 23.265l-0.113-0.038-2.064 4.953c-0.45 1.126 0.075 2.402 1.201 2.889l0.113 0.038 2.064-4.953c0.45-1.126-0.075-2.402-1.201-2.889z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M49.081 28.218c0-0.038 0-0.075 0-0.113-0.038-0.6-0.563-1.051-1.163-1.013h-1.463v3.452h0.713v-1.238h0.413l0.75 1.238h0.863l-0.863-1.313c0.45-0.113 0.75-0.525 0.75-1.013zM47.843 28.668h-0.675v-0.901h0.675c0.038 0 0.038 0 0.075 0 0.225 0.038 0.413 0.225 0.413 0.488-0.038 0.225-0.263 0.413-0.488 0.413z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M61.726 27.092v3.452h0.713v-3.452h-0.713z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M57.636 30.545h0.713v-1.426h1.651v-0.638h-1.651v-0.713h1.688v-0.675h-2.401v3.452z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M8.931 1.576l-0.113 0.038 2.026 4.953c0.225 0.525 0.638 0.976 1.201 1.201 0.263 0.113 0.563 0.188 0.863 0.188s0.563-0.075 0.826-0.188l0.15-0.038-2.026-4.953c-0.488-1.126-1.801-1.651-2.927-1.201z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M50.582 27.768h0.976v2.777h0.75v-2.777h0.976v-0.675h-2.702v0.675z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M80 23.115h-42.626v0.826h42.626v-0.826z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M64.353 30.545h2.402v-0.675h-1.651v-0.75h1.614v-0.638h-1.614v-0.713h1.651v-0.675h-2.402v3.452z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M42.252 30.545h2.402v-0.675h-1.689v-0.75h1.651v-0.638h-1.651v-0.713h1.689v-0.675h-2.402v3.452z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M69.831 27.092h-1.276v3.452h1.276c0.976 0 1.726-0.788 1.726-1.726s-0.788-1.726-1.726-1.726zM69.831 29.907h-0.525v-2.139h0.525c0.038 0 0.075 0 0.15 0 0.525 0.038 0.938 0.525 0.901 1.051 0 0.038 0 0.075 0 0.113-0.038 0.563-0.525 0.976-1.051 0.976z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M55.685 27.092h-0.713v3.452h0.713v-3.452z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M23.302 20.113l-0.075 0.113 4.991 2.101c0.263 0.113 0.563 0.15 0.826 0.15 0.901 0 1.689-0.525 2.026-1.351l0.038-0.113-4.953-2.064c-1.088-0.488-2.364 0.038-2.852 1.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M24.278 22.589c-0.863-0.863-2.251-0.863-3.114 0l-0.113 0.113 3.79 3.79c0.863 0.863 2.251 0.863 3.114 0l0.113-0.113-3.79-3.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M21.088 25.291c-0.45-1.126-1.726-1.651-2.852-1.201l-0.15 0.038 1.989 4.953c0.225 0.525 0.638 0.976 1.201 1.201 0.263 0.113 0.563 0.188 0.863 0.188s0.563-0.075 0.826-0.188l0.15-0.038-2.026-4.953z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M14.934 0h-0.15v5.366c0 1.201 0.976 2.176 2.214 2.176h0.15v-5.366c0-1.201-1.013-2.176-2.214-2.176z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M14.934 24.315h-0.15v5.366c0 1.238 0.976 2.214 2.214 2.214h0.15v-5.366c0-1.201-1.013-2.214-2.214-2.214z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M24.353 16.998v0.113h5.366c1.238 0 2.214-1.013 2.214-2.214v-0.113h-5.366c-1.238 0-2.214 1.013-2.214 2.214z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M39.888 11.144c1.201 0.038 2.289-0.6 2.852-1.651l0.038-0.038-1.276-0.6v0.038c-0.3 0.6-0.901 0.938-1.576 0.938-0.038 0-0.075 0-0.075 0-1.126-0.075-1.989-1.013-1.914-2.139 0-0.038 0-0.038 0-0.075 0-1.126 0.901-2.026 1.989-2.064 0.675 0 1.276 0.375 1.576 0.938v0.038l1.276-0.638v-0.038c-0.563-1.051-1.689-1.689-2.852-1.651-0.075 0-0.15 0-0.225 0-1.876 0.038-3.34 1.576-3.302 3.452 0 0.075 0 0.15 0 0.225 0.075 1.876 1.651 3.34 3.49 3.265z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M38.162 15.535l2.889 4.315h1.313v-6.642h-1.388v4.165l-2.777-4.165h-1.388l-0.038 6.642h1.388v-4.315z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M39.175 27.73c0.3 0 0.6 0.15 0.75 0.413l0.075 0.113 0.638-0.338-0.075-0.113c-0.3-0.488-0.825-0.75-1.388-0.75-0.976 0-1.801 0.788-1.801 1.801s0.788 1.801 1.801 1.801c0.563 0 1.088-0.263 1.388-0.75l0.075-0.075-0.638-0.338-0.075 0.113c-0.15 0.263-0.45 0.413-0.75 0.413-0.488-0.075-0.901-0.45-0.938-0.938-0.113-0.675 0.338-1.238 0.938-1.351z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-download",
    viewBox: "0 0 50 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M1.345 31.135h1.635c1.441 0 2.216-0.303 2.954-0.932 0.581-0.496 1.417-1.405 1.417-3.1 0-1.453-0.642-2.482-1.38-3.1-1.017-0.86-2.167-0.944-2.979-0.944h-1.647v8.076zM2.24 23.907h0.787c2.046 0 3.402 1.259 3.402 3.197 0 1.15-0.484 1.949-1.090 2.458-0.787 0.654-1.671 0.727-2.313 0.727h-0.787v-6.381zM11.126 31.28c1.526 0 2.664-1.114 2.664-2.64s-1.126-2.652-2.664-2.652c-1.538 0-2.664 1.126-2.664 2.652s1.138 2.64 2.664 2.64zM11.126 26.764c0.92 0 1.768 0.642 1.768 1.877 0 1.223-0.86 1.865-1.768 1.865-0.896 0-1.768-0.63-1.768-1.865 0-1.223 0.848-1.877 1.768-1.877zM14.4 26.11l2.47 5.376 1.55-3.753 1.55 3.753 2.494-5.376h-0.969l-1.501 3.415-1.562-3.802-1.574 3.802-1.489-3.415h-0.969zM23.38 31.135h0.872v-2.627c0-0.363 0.024-0.957 0.363-1.356 0.254-0.303 0.581-0.387 0.884-0.387 0.387 0 0.654 0.145 0.823 0.363 0.206 0.266 0.23 0.617 0.23 0.92v3.088h0.872v-3.112c0-0.557-0.036-0.969-0.291-1.344-0.303-0.448-0.848-0.69-1.441-0.69-0.835 0-1.283 0.496-1.441 0.702v-0.581h-0.872v5.025zM29.067 22.308v8.827h0.872v-8.827h-0.872zM33.935 31.28c1.526 0 2.664-1.114 2.664-2.64s-1.126-2.652-2.664-2.652c-1.538 0-2.664 1.126-2.664 2.652s1.138 2.64 2.664 2.64zM33.935 26.764c0.92 0 1.768 0.642 1.768 1.877 0 1.223-0.86 1.865-1.768 1.865-0.896 0-1.768-0.63-1.768-1.865 0-1.223 0.848-1.877 1.768-1.877zM41.786 26.825c-0.23-0.303-0.751-0.835-1.719-0.835-1.283 0-2.446 0.896-2.446 2.627 0 1.768 1.175 2.664 2.446 2.664 0.884 0 1.429-0.472 1.719-0.848v0.702h0.872v-5.025h-0.872v0.714zM40.164 26.764c0.775 0 1.671 0.569 1.671 1.865 0 0.993-0.605 1.877-1.671 1.877-1.041 0-1.647-0.811-1.647-1.889 0-1.223 0.787-1.853 1.647-1.853zM48.159 26.825c-0.23-0.303-0.751-0.835-1.719-0.835-1.283 0-2.446 0.896-2.446 2.627 0 1.768 1.175 2.664 2.446 2.664 0.884 0 1.429-0.472 1.719-0.848v0.702h0.872v-8.827h-0.872v4.516zM46.537 26.764c0.775 0 1.671 0.569 1.671 1.865 0 0.993-0.605 1.877-1.671 1.877-1.041 0-1.647-0.811-1.647-1.889 0-1.223 0.787-1.853 1.647-1.853z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M24.102 0v11.245l-4.916-4.916-0.772 0.772 6.235 6.235 6.235-6.235-0.772-0.772-4.916 4.916v-11.245h-1.092z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M14.27 17.081h20.757v1.081h-20.757v-1.081z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-share",
    viewBox: "0 0 28 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M5.48 24.185c-0.182-0.351-0.46-0.678-0.787-0.896-0.4-0.266-0.799-0.363-1.296-0.363-1.308 0-2.264 0.835-2.264 2.083 0 0.605 0.206 0.981 0.557 1.32 0.363 0.351 0.763 0.521 1.078 0.666l0.727 0.339c0.424 0.194 0.739 0.339 0.969 0.557 0.291 0.266 0.4 0.581 0.4 0.944 0 0.811-0.521 1.598-1.623 1.598-0.412 0-0.811-0.097-1.162-0.448-0.23-0.242-0.424-0.605-0.484-1.029l-0.872 0.242c0.109 0.484 0.351 1.041 0.751 1.429 0.557 0.545 1.223 0.654 1.756 0.654 1.453 0 2.555-0.993 2.555-2.482 0-0.581-0.17-1.053-0.581-1.465-0.339-0.339-0.775-0.557-1.247-0.763l-0.775-0.339c-0.303-0.133-0.605-0.266-0.848-0.509-0.218-0.206-0.303-0.387-0.303-0.702 0-0.751 0.557-1.247 1.356-1.247 0.46 0 0.751 0.157 0.908 0.279 0.182 0.145 0.363 0.387 0.472 0.605l0.714-0.472zM7.206 31.135h0.872v-2.627c0-0.363 0.024-0.957 0.363-1.356 0.254-0.303 0.581-0.387 0.884-0.387 0.387 0 0.654 0.145 0.823 0.363 0.206 0.266 0.23 0.617 0.23 0.92v3.088h0.872v-3.112c0-0.557-0.036-0.969-0.291-1.344-0.303-0.448-0.848-0.69-1.441-0.69-0.835 0-1.283 0.496-1.441 0.702v-4.383h-0.872v8.827zM16.744 26.825c-0.23-0.303-0.751-0.835-1.719-0.835-1.283 0-2.446 0.896-2.446 2.627 0 1.768 1.175 2.664 2.446 2.664 0.884 0 1.429-0.472 1.719-0.848v0.702h0.872v-5.025h-0.872v0.714zM15.121 26.764c0.775 0 1.671 0.569 1.671 1.865 0 0.993-0.605 1.877-1.671 1.877-1.041 0-1.647-0.811-1.647-1.889 0-1.223 0.787-1.853 1.647-1.853zM19.267 31.135h0.872v-2.652c0-0.823 0.145-1.162 0.291-1.356 0.133-0.169 0.351-0.315 0.702-0.315 0.133 0 0.315 0.036 0.509 0.169l0.412-0.787c-0.218-0.109-0.509-0.206-0.775-0.206-0.678 0-1.053 0.533-1.138 0.666v-0.545h-0.872v5.025zM26.283 29.452c-0.109 0.242-0.291 0.496-0.521 0.69-0.291 0.242-0.617 0.363-1.029 0.363-0.872 0-1.586-0.666-1.598-1.707h3.911c0.024-0.666-0.157-1.441-0.472-1.889-0.303-0.436-0.92-0.92-1.901-0.92-1.514 0-2.434 1.162-2.434 2.664 0 1.865 1.271 2.627 2.482 2.627 0.642 0 1.211-0.206 1.671-0.617 0.254-0.23 0.472-0.533 0.617-0.811l-0.727-0.4zM23.196 28.072c0.133-0.751 0.739-1.308 1.477-1.308s1.332 0.521 1.477 1.308h-2.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M23.173 17.094h-18.162v-16.025h6.944v-1.068h-8.013v18.162h20.299v-5.876h-1.068v4.808z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M15.694 0v1.068h6.723l-8.013 8.013 0.755 0.755 8.013-8.013v6.723h1.068v-8.547h-8.547z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.86ad8f3a02e662a3a1067ea896b9abee.svg";
export { ForwardRef as ReactComponent };